var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkayOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "general/feedback/okay-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,19.668 C3,28.856 10.477,36.334 19.667,36.334 L19.667,36.334 C28.857,36.334 36.333,28.856 36.333,19.668 L36.333,19.668 C36.333,10.477 28.857,3 19.667,3 L19.667,3 C10.477,3 3,10.477 3,19.668 L3,19.668 Z M5.667,19.668 C5.667,11.947 11.948,5.667 19.667,5.667 L19.667,5.667 C27.386,5.667 33.667,11.947 33.667,19.668 L33.667,19.668 C33.667,27.386 27.386,33.667 19.667,33.667 L19.667,33.667 C11.948,33.667 5.667,27.386 5.667,19.668 L5.667,19.668 Z M23.001,17.156 C23.001,18.53 24.115,19.644 25.488,19.644 L25.488,19.644 C26.863,19.644 27.977,18.53 27.977,17.156 L27.977,17.156 C27.977,15.78 26.863,14.667 25.488,14.667 L25.488,14.667 C24.115,14.667 23.001,15.78 23.001,17.156 L23.001,17.156 Z M11.333,17.167 C11.333,18.547 12.453,19.668 13.833,19.668 L13.833,19.668 C15.214,19.668 16.334,18.547 16.334,17.167 L16.334,17.167 C16.334,15.787 15.214,14.667 13.833,14.667 L13.833,14.667 C12.453,14.667 11.333,15.787 11.333,17.167 L11.333,17.167 Z M12.957,27.724 L26.334,27.724 L26.334,24.974 L12.957,24.974 L12.957,27.724 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "general/feedback/okay-on",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,19.668 C3,28.856 10.476,36.334 19.666,36.334 L19.666,36.334 C28.856,36.334 36.333,28.856 36.333,19.668 L36.333,19.668 C36.333,10.477 28.856,3 19.666,3 L19.666,3 C10.476,3 3,10.477 3,19.668 L3,19.668 Z",
    id: "Path",
    fill: "#A1E9FF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-2",
    fill: "#000000",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkayOn);
export default __webpack_public_path__ + "static/media/okay-on.fb89c8507f6fa2a010e0acd6c821cd61.svg";
export { ForwardRef as ReactComponent };